import { scrollToElement } from "../components/_scrollto";
import Button from "../components/_button";

class TBC {
  button: Button;
  classes = {
    content: ".tbc_content",
    list: ".tbc_list",
  };

  content;
  list;

  constructor() {
    this.button = new Button();
    this.button.state(".js-collapse");
    this.content = document.querySelector(this.classes.content);
    this.list = document.querySelector(this.classes.list);
    this.generateTitles();
    this.activeScroll();
    this.anchorsScroll();
  }

  generateTitles() {
    if (!this.content) return;
    var toc = "";
    var level = 0;

    this.content.innerHTML = this.content.innerHTML.replace(
      /<h(2)>([^<]+)<\/h(2)>/gi,
      function (str, openLevel, titleText, closeLevel) {
        if (openLevel != closeLevel) {
          return str;
        }

        level = parseInt(openLevel);

        var anchor = titleText
          .toLowerCase()
          .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "")
          .replace(/[0-9]/g, "_")
          .replace(/ +/g, "_");

        toc += `<li><a class="js-anchor" href="#${anchor}">${titleText}</a></li>`;

        return `<h${openLevel} id="${anchor}">${titleText}</h${closeLevel}>`;
      }
    );
    if (level) {
      toc += new Array(level + 1).join("</ul>");
    }

    this.list.innerHTML += toc;
  }

  activeScroll() {
    let menuSection = this.list.querySelectorAll("li") as any;
    menuSection.forEach((link) => {
      link.addEventListener("click", () => {
        setTimeout(() => {
          menuSection.forEach((j) => j.classList.remove("active"));
          link.classList.add("active");
        }, 300);
      });
    });

    document.onscroll = () => {
      let mainSection = this.content.querySelectorAll("h2") as any;
      mainSection.forEach((v, i) => {
        let rect = v.getBoundingClientRect().y;
        if (rect < window.innerHeight - 500) {
          menuSection.forEach((v) => v.classList.remove("active"));
          menuSection[i].classList.add("active");
        }
      });
    };
  }

  anchorsScroll() {
    const anchors = document.querySelectorAll(".js-anchor");

    anchors.forEach((anchor) =>
      anchor.addEventListener("click", (e) => {
        const href = (anchor as HTMLLinkElement).getAttribute("href");
        const element = document.querySelector(href);
        if (element) {
          e.preventDefault();
          // this.body.classList.remove('mso');
          scrollToElement(href);
        }
      })
    );
  }
}

new TBC();
